import React, { useEffect, useState } from "react";
import "./BasicInfoForm.css";
import { Form, Input, Button, message, Space, Flex } from "antd";
import { RestaurantService } from "deliziora-client-module/client-web";
import UploadImages from "../UploadImages/Upload";
import CharacterLimitedTextArea from "../CharacterLimitedTextArea/CharacterLimitedTextArea";
export default function BasicInfoForm() {
  const restaurant = JSON.parse(localStorage.getItem("userData"));
  const [form] = Form.useForm();

  useEffect(() => {
    RestaurantService.returnRestaurantById(restaurant._id.$oid)
      .then((res) => {
        form.setFieldsValue(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [restaurant]);
  const onFinish = (values) => {
    const restaurantValue = JSON.parse(localStorage.getItem("userData"));
    RestaurantService.updateRestaurantById({
      id_restaurant: restaurantValue._id.$oid,
      name: values.name,
      address: values.address,
      latitude: restaurantValue.latitude,
      especialty: restaurantValue.especialty,
      complete_menu: restaurantValue.complete_menu,
      email: values.email,
      opening_hours: restaurantValue.opening_hours,
      longitude: restaurantValue.longitude,
      contact: values.contact,
      description: values.description,
      img: restaurantValue.img,
      categories: restaurantValue.categories,
      characteristics: restaurantValue.characteristics,
      updated_at: "",
    })
      .then((res) => {
        console.log(res.data);
        message.success("Dados actualizados com sucesso!");
        setInterval(() => {
          RestaurantService.returnRestaurantById(restaurant._id.$oid)
            .then((res) => {
              form.setFieldsValue(res.data);
              localStorage.setItem("userData", JSON.stringify(res.data));
              window.location.reload();
            })
            .catch((err) => {
              console.error(err);
            });
        }, 1000);
      })
      .catch((err) => console.log(err));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Falha no envio do formulário:", errorInfo);
  };

  return (
    <>
      <Form
        form={form}
        name="form"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelAlign="left"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "90%",
          justifyContent: "space-between",
          padding: "1rem",
        }}
      >
        <Form.Item
          name="name"
          label="Nome"
          rules={[{ required: true, message: "Por favor, insira o nome." }]}
        >
          <Input
            type="text"
            placeholder="Restaurante"
            className="input-form-profile"
          />
        </Form.Item>
        <Form.Item
          name="address"
          label="Endereço Completo"
          style={{ width: "100%" }}
          rules={[{ required: true, message: "Por favor, insira o endereço." }]}
        >
          <Input placeholder="Avenida Luísa Todi N° 0 , 0000-000 Setúbal" />
        </Form.Item>
        <Form.Item
          name="contact"
          label="Telefone"
          style={{ width: "50%" }}
          rules={[
            { required: true, message: "Por favor, insira o telefone 1." },
          ]}
        >
          <Input
            type="tel"
            placeholder="123 456 789"
            className="input-form-profile-minify"
          />
        </Form.Item>
        <Form.Item
          name="email"
          label="Endereço de Email"
          rules={[
            {
              required: true,
              message: "Por favor, insira o endereço de email.",
            },
            { type: "email", message: "Endereço de email inválido." },
          ]}
        >
          <Input
            type="email"
            placeholder="restaurante@email.pt"
            className="input-form-profile"
            disabled={true}
          />
        </Form.Item>
        <Form.Item
          name="description"
          label="Descrição"
          rules={[
            {
              required: true,
              message: "Por favor, insira a descrição do restaurante.",
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Salvar
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
